import request from "@/utils/request.js";

// 获取内容管理详细信息
export function getContentInfo(contentId) {
    return request({
        url: "/website/content/getContentInfo/" + contentId,
        method: "get",
    });
}

// 获取卡片列表内容管理详细信息
export function listCardContent() {
    return request({
        url: "/website/content/listCardContent" ,
        method: "get",
    });
}

